angular.module('rjmNg.controllers').controller('deleteDashCtrl', [
  "$scope"
  "$modal"
  "$location"
  "appRoute"
  "Dashboard"
  "dashboardService"
  "app"
  ($scope, $modal, $location, appRoute, Dashboard, dashboardService, app) ->

    $scope.deleteDashboard = (modal) ->
      Dashboard.delete(
        id: $scope.dashboard.id
        clientId: app.getClientId()
        , ->
          modal('hide')
          app.deleteDashboard($scope.dashboard.id)
          dashboardService.updateGlobalSearch()
          $location.path appRoute("/")
      )
])
